import axios from "src/lib/axios";

//product find all admin
export const getProductListAdmin = ({
  keyword = null,
  page = null,
  page_size = null,
  // order_case = "desc",
  status = "all",
  fromDate,
  toDate,
  sortBy,
  sortOrder,
  seller = "all",
}) => {
  return axios.get(`/products/search-admin`, {
    params: {
      keyword: keyword,
      page: page,
      page_size: page_size,
      status: status,
      fromDate: fromDate,
      toDate: toDate,
      sortBy: sortBy,
      sortOrder: sortOrder,
      seller: seller,
    },
  });
};

export const getProductCsvDataAdmin = ({
  keyword = null,
  page = null,
  page_size = null,
  order_case = "desc",
  status = "all",
  seller = null,
  fromDate,
  toDate,
}) => {
  return axios.get(`/products/csv-admin`, {
    params: {
      keyword: keyword,
      order_case: order_case,
      status: status,
      user: seller,
      fromDate: fromDate,
      toDate: toDate,
    },
  });
};
//product find all seller
export const getProductListSeller = ({
  keyword = null,
  page = null,
  page_size = null,
  // order_case = "desc",
  status = "all",
  fromDate,
  toDate,
  sortBy,
  sortOrder,
}) => {
  return axios.get(`/products/search-seller`, {
    params: {
      keyword: keyword,
      page: page,
      page_size: page_size,
      status: status,
      fromDate: fromDate,
      toDate: toDate,
      sortBy: sortBy,
      sortOrder: sortOrder,
    },
  });
};

// search product
export const searchProduct = ({
  keyword = null,
  first_price = 0,
  last_price = 100000,
  pageCurrent = null,
  page_size = null,
  order = "asc",
  key_order = "default",
  product_type = "",
  brand = "",
  color = "",
  texture = "",
  patterns = "",
  cate = "",
  not_in_deal = null,
  deal_group_id = "",
  pre_order = null,
  ready_to_sell = null,
}) => {
  let pageConvert =
    isNaN(parseInt(pageCurrent)) !== true ? parseInt(pageCurrent) : 1;
  let page = pageConvert > 0 ? pageConvert - 1 : pageConvert;
  return axios.get("/products/search", {
    params: {
      keyword,
      first_price,
      last_price,
      page,
      page_size,
      order,
      key_order,
      product_type,
      brand,
      color,
      texture,
      patterns,
      cate,
      not_in_deal,
      deal_group_id,
      pre_order,
      ready_to_sell,
    },
  });
};
export const searchProductAdmin = ({
  keyword = null,
  seller_id = "",
  pageCurrent = null,
  page_size = null,
}) => {
  let pageConvert =
    isNaN(parseInt(pageCurrent)) !== true ? parseInt(pageCurrent) : 1;
  let page = pageConvert > 0 ? pageConvert - 1 : pageConvert;
  return axios.get("/products/search-e-amin", {
    params: {
      keyword,
      seller_id,
      page,
      page_size,
    },
  });
};

//create product
export const createProduct = (dataProduct) => {
  return axios.post(`/products`, dataProduct, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};

//update product
export const updateProduct = (dataProduct) => {
  return axios.patch(`/products`, dataProduct, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};

//product upload find one
export const getDataProductDetail = (id) => {
  return axios.get(`/products/backend/${id}`);
};

//delete product
export const deleteProduct = (id) => {
  return axios.delete(`/product`, {
    data: {
      id: id,
    },
  });
};

export const holdProduct = (id) => {
  return axios.patch(`/product-hold`, {
    id: id,
  });
};

export const unHoldProduct = (id) => {
  return axios.patch(`/product-unhold`, {
    id: id,
  });
};

export const requestDeleteProduct = (id) => {
  return axios.patch(`/product-request-delete`, {
    id: id,
  });
};

export const requestHoldProduct = (id) => {
  return axios.patch(`/product-request-hold`, {
    id: id,
  });
};

export const requestUnHoldProduct = (id) => {
  return axios.patch(`/product-request-unhold`, {
    id: id,
  });
};

export const clearRequestProduct = (id) => {
  return axios.patch(`/product-clear-request`, {
    id: id,
  });
};

//Product detail
export const getDataProductDetailApprove = (id) => {
  return axios.get(`products/approve/${id}`);
};

//approve
export const ChangeStatus = (id, status) => {
  return axios.patch(`/products/status/${id}`, {
    id: id,
    status: status,
  });
};

// update product by seller (status: pending)
export const updatePendingProduct = (dataProduct) => {
  return axios.patch(`/pending-products`, dataProduct);
};

// approve pending product
export const approvePendingProduct = (id) => {
  return axios.patch(`/approve-pending-product/${id}`);
};

// create draft
export const createDraftProduct = (dataProduct) => {
  return axios.post(`/draft-products`, dataProduct);
};

// update draft product
export const updateDraftProduct = (dataProduct) => {
  return axios.patch(`/draft-products`, dataProduct);
};

// publish product
export const updateProductPublic = (product_id, is_public) => {
  return axios.patch(`/product/public/${product_id}`, {
    is_public: is_public,
  });
};

// update stock
export const updateProductStock = (choice_id, is_instock) => {
  return axios.patch(`/product/stock/${choice_id}`, {
    is_instock: is_instock,
  });
};

// new update stock (is_instock, stock_count)
/**
 *
 * @param {ObjectId} choice_id - product_choice _id
 * @param {Object} info
 * @param {boolean} info.is_instock - true=instock, false=out of stock
 * @param {number} info.stock_count - stock count number
 * @returns
 */
export const updateProductStockInfo = (choice_id, info) => {
  return axios.put(`/stock-update/${choice_id}`, {
    is_instock: info.is_instock,
    stock_count: info.stock_count,
  });
};

// update many stock (data_product, is_instock)
/**
 *
 * @param {ObjectId[]} data_product - array of product_choice _id
 * @param {boolean} is_instock - true=instock, false=out of stock
 * @returns
 */
export const updateMultipleStock = (data_product, is_instock) => {
  return axios.put(`/update-many-instock`, {
    is_instock: is_instock,
    data_product: data_product,
  });
};

/**
 *
 * @param {ObjectId} id - user id of seller
 * @returns
 */
export const getProductStockCsvData = (id) => {
  return axios.get(`/stocks-csv/${id}`);
};

/**
 *
 * @param {object} data
 * @param {ObjectId} data.userId - user id of seller
 * @param {File} data.stock_csv - csv file
 * @returns
 */
export const importProductStockCsvData = (data) => {
  return axios.put(`/update-stock-from-csv`, data, {
    headers: {
      "Content-Type": "multipart/form-data", // do not forget this
    },
  });
};

//approve
export const approveAllSelectedProduct = (data_product_approve) => {
  return axios.patch(`/products/approve-all`, {
    data_product: data_product_approve,
  });
};

// //list find all
// export const getCustomerList = ({
//   customer = null,
//   sale = null,
//   contact = null,
//   project = null,
//   type = null,
//   start_date = null,
//   end_date = null,
// }) => {
//   return axios.get(`/customers-admin`, {
//     params: {
//       customer,
//       sale,
//       contact,
//       project,
//       type,
//       start_date,
//       end_date,
//     },
//   })
// }

// export const getCustomerTypeList = () => {
//   return axios.get(`/customerType`)
// }

// //detail
// export const getCustomerDetail = (id) => {
//   return axios.get(`/customer?_id=${id}`)
// }

// //create
// export const createCustomer = (dataProduct) => {
//   return axios.post(`/customer`, dataCustomer, {
//     headers: {
//       'Content-Type': 'multipart/form-data', // do not forget this
//     },
//   })
// }

// //delete
// export const deleteCustomer = (id) => {
//   return axios.delete(`/customer?_id=${id}`)
// }

// //update
// export const updateCustomer = (dataCustomer) => {
//   return axios.patch(`/customer`, dataCustomer, {
//     headers: {
//       'Content-Type': 'multipart/form-data', // do not forget this
//     },
//   })
// }

// //contact find all
// export const getContactListByCustomer = ({
//   customer_id = null,
//   sale_id = null,
//   name = null,
// }) => {
//   return axios.get(`/contacts-admin`, {
//     params: {
//       customer_id,
//       sale_id,
//       name,
//     },
//   })
// }

// //contact find one
// export const getContactDetailByCustomer = (id) => {
//   return axios.get(`/contact?_id=${id}`)
// }

// //create contact
// export const createContactByCustomer = (dataContact) => {
//   return axios.post(`/contact-admin`, dataContact, {
//     headers: {
//       'Content-Type': 'multipart/form-data', // do not forget this
//     },
//   })
// }

// //update contact
// export const updateContactByCustomer = (dataContact) => {
//   return axios.patch(`/contact-admin`, dataContact, {
//     headers: {
//       'Content-Type': 'multipart/form-data', // do not forget this
//     },
//   })
// }

// //delete contact
// export const deleteContactByCustomer = (id) => {
//   return axios.delete(`/contact?_id=${id}`)
// }

// //project find all
// export const getProjectListByCustomer = ({
//   customer_id = null,
//   sale_id = null,
//   name = null,
// }) => {
//   return axios.get(`/projects-admin`, {
//     params: {
//       customer_id,
//       sale_id,
//       name,
//     },
//   })
// }

// //project find one
// export const getProjectDetailByCustomer = (id) => {
//   return axios.get(`/project?_id=${id}`)
// }

// //delete project
// export const deleteProjectByCustomer = (id) => {
//   return axios.delete(`/project?_id=${id}`)
// }

// //get all sale for select
// export const getAllSaleByCustomer = () => {
//   return axios.get('/sales')
// }

// //get customers-sale-by-admin
// export const getCustomersSaleByAdmin = (id) => {
//   return axios.get(`/customers-sale-by-admin?sale_id=${id}`)
// }
